import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '../../../../components';
import { useSegmentContext } from '../../../FlightsManager/Segment/SegmentManager/Context';
import { DateUtils } from '../../../../utils';
import { ConnectedSegmentDate } from '../../../FlightsManager/Segment/SegmentDate';
import CalendarContextProvider from '../../../FlightsManager/CalendarContext';
import { DateTypeDefault, DateTypeProp } from '../../../../models';
import { DatePickerError } from './DatePickerError';

export const HotelDateDesktop = ({ onChangeFocus, open, placeholderKey, dateType }) => {
    const { t } = useTranslation();
    const { segment } = useSegmentContext();
    const { id } = segment;
    const maxDays = DateUtils.MAX_DAYS_PRIME_HOTEL;
    return (
        <CalendarContextProvider>
            <ConnectedSegmentDate segmentId={id} maxDays={maxDays} minDays={1}>
                {({ error, dates, minDate, maxDate, setValue, value }) => (
                    <DatePicker
                        value={value}
                        onSelect={setValue}
                        dates={dates}
                        isDatesRangeShown
                        maxDate={maxDate}
                        minDate={minDate}
                        placeholder={t(placeholderKey)}
                        validationError={error}
                        open={open}
                        onChangeFocus={onChangeFocus}
                        dateType={dateType}
                        DatePickerError={DatePickerError}
                    />
                )}
            </ConnectedSegmentDate>
        </CalendarContextProvider>
    );
};

HotelDateDesktop.propTypes = {
    onChangeFocus: PropTypes.func.isRequired,
    open: PropTypes.bool,
    placeholderKey: PropTypes.string.isRequired,
    dateType: DateTypeProp,
};

HotelDateDesktop.defaultProps = {
    open: false,
    dateType: DateTypeDefault,
};
